import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Button, Dialog } from '@dsi/react-eds';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';

interface PropsObject {
    onConfirm: () => Promise<void>;
    onCancel: () => void;
    classes?: string;
    open: boolean;
    title: string;
    subtitle: string | undefined;
    buttonText: string;
    innerText: string;
}

const ConfirmDialog = (props: PropsObject) => {

    useEffect(() => {
        if (props.open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [props.open]);

    return ReactDOM.createPortal(
        <ReactEDSWrapper
        component={Dialog}
        show={props.open}
        className={props.classes}
        onClose={props.onCancel}
        title={props.title}
        subtitle={props.subtitle}
        bottom={
            <ReactEDSWrapper
            component={Button}
            variant="primary"
            className="btn primary"
            type="button"
            onClick={props.onConfirm}
            >
                {props.buttonText ? props.buttonText : 'Confirm'}
            </ReactEDSWrapper>
        }
        >
        <div dangerouslySetInnerHTML={{__html: props.innerText}}>
        </div>
        </ReactEDSWrapper>, document.body
    );
}
export default ConfirmDialog;